export function getSplittedPathname(pathname: string) {
  return (pathname.startsWith("/") ? pathname.slice(1, pathname.length) : pathname).split("/")
}
